module.exports = __webpack_public_path__ + "img/MU.6b4d1e82.svg";